import React from 'react'
import { AppRouter } from '@app/router/AppRouter'
import { WidgetWithConfigurationHOC, WidgetWithConfigurationProps } from './WidgetHOC'

export const DrawerWidget: React.FC<WidgetWithConfigurationProps> = ({
  customerContext,
  actionModule,
  environment,
  widgetContext,
}) => {
  return (
    <WidgetWithConfigurationHOC
      customerContext={customerContext}
      environment={environment}
      actionModule={actionModule}
      widgetContext={widgetContext}
    >
      <AppRouter />
    </WidgetWithConfigurationHOC>
  )
}
